module.exports = __webpack_public_path__ + "images/drawings/cloudB.b27dbe1cc997a42cb81135c05e83df8e.png";